export const aboutData = {
    title: "Who I am",
    description1: "My name is Hannan Shehzad. I'm a Full Stack developer with experience in Mobile app development (React native) based in Lahore, Pakistan.",
    description2: "I am a dedicated and enthusiastic programmer in my daily endeavors, embodying professionalism and a deep passion for my craft. With a natural aptitude for rapid learning and a self-driven approach to acquiring new skills, I am committed to continuous improvement. My zeal for delving into cutting-edge technologies is matched only by my fervor for effective problem solving. My devotion extends to a comprehensive range of software engineering stacks, and my present focus encompasses an array of technologies including: ",
    skills: [
        "React",
        "React Native",
        "Redux Toolkit",
        "WebSockets",
        "Firebase",
        "OAuth",
        "JavaScript",
        "Node JS",
        "Experss",
        "MongoDB",
        "Sequelize ORM",
        "Bootstrap",
        "Material UI",
        "Tailwind",        
        "Shopify"

        // Add more skills as needed
    ],
};
